import {CommonModule} from '@angular/common';
import {Component, inject, input} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {ClinicalRegistry} from 'src/domain/clinical-record/clinical-record';
import {RecordCardComponent} from './record-card/record-card.component';

@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.scss'],
    standalone: true,
    imports: [
        RouterOutlet,
        TranslateModule,
        AngularSvgIconModule,
        CommonModule,
        RecordCardComponent
    ]
})
export class TimelineComponent
{
    public readonly timelineRecords = input.required<Map<number, ClinicalRegistry[]>>();

    private readonly translate = inject(TranslateService);

    public getRecordMonth(record: ClinicalRegistry): string
    {
        const month = new Date(record?.date ?? record?.startDate).toLocaleString(this.translate.currentLang, { month: 'short' }).replace('.', '');

        return month.charAt(0).toUpperCase() + month.slice(1);
    }

    public getYears(): string[]
    {
        return Object.keys(this.timelineRecords());
    }
}
